var moduleMap = {
	"./CustomerContext": () => {
		return __webpack_require__.e("src_context_CustomerContext_jsx").then(() => (() => ((__webpack_require__(/*! ./src/context/CustomerContext */ "./src/context/CustomerContext.jsx")))));
	},
	"./Customers": () => {
		return __webpack_require__.e("src_pages_customers_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/customers */ "./src/pages/customers.tsx")))));
	},
	"./Customer": () => {
		return __webpack_require__.e("src_pages_customer_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/customer */ "./src/pages/customer.tsx")))));
	},
	"./PrimaryDocSelection": () => {
		return __webpack_require__.e("src_pages_stepup_primary-doc-selection_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/primary-doc-selection */ "./src/pages/stepup/primary-doc-selection.tsx")))));
	},
	"./InterstateLicence": () => {
		return __webpack_require__.e("src_pages_stepup_stepup-docs_interstate-licence_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/stepup-docs/interstate-licence */ "./src/pages/stepup/stepup-docs/interstate-licence.tsx")))));
	},
	"./SecondaryDocSelection": () => {
		return __webpack_require__.e("src_pages_stepup_secondary-doc-selection_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/secondary-doc-selection */ "./src/pages/stepup/secondary-doc-selection.tsx")))));
	},
	"./Passport": () => {
		return __webpack_require__.e("src_pages_stepup_secondary-docs_passport_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/secondary-docs/passport */ "./src/pages/stepup/secondary-docs/passport.tsx")))));
	},
	"./Visa": () => {
		return __webpack_require__.e("src_pages_stepup_secondary-docs_visa_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/secondary-docs/visa */ "./src/pages/stepup/secondary-docs/visa.tsx")))));
	},
	"./BirthCertificate": () => {
		return __webpack_require__.e("src_pages_stepup_secondary-docs_birth-certificate_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/secondary-docs/birth-certificate */ "./src/pages/stepup/secondary-docs/birth-certificate.tsx")))));
	},
	"./Citizenship": () => {
		return __webpack_require__.e("src_pages_stepup_secondary-docs_citizenship-certificate_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/secondary-docs/citizenship-certificate */ "./src/pages/stepup/secondary-docs/citizenship-certificate.tsx")))));
	},
	"./ImmiCard": () => {
		return __webpack_require__.e("src_pages_stepup_secondary-docs_immicard_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/secondary-docs/immicard */ "./src/pages/stepup/secondary-docs/immicard.tsx")))));
	},
	"./MedicareCard": () => {
		return __webpack_require__.e("src_pages_stepup_secondary-docs_medicare-card_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/secondary-docs/medicare-card */ "./src/pages/stepup/secondary-docs/medicare-card.tsx")))));
	},
	"./NonDVSGroup3DocumentsPage": () => {
		return __webpack_require__.e("src_pages_stepup_stepup-docs_non-dvs-group-3-documents_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/stepup-docs/non-dvs-group-3-documents */ "./src/pages/stepup/stepup-docs/non-dvs-group-3-documents.tsx")))));
	},
	"./FirstCredentialUploadSuccess": () => {
		return __webpack_require__.e("src_pages_stepup_stepup-docs_first-cred-upload-success_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/stepup-docs/first-cred-upload-success */ "./src/pages/stepup/stepup-docs/first-cred-upload-success.tsx")))));
	},
	"./SecondCredentialUploadSuccess": () => {
		return __webpack_require__.e("src_pages_stepup_secondary-docs_second-cred-upload-success_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/secondary-docs/second-cred-upload-success */ "./src/pages/stepup/secondary-docs/second-cred-upload-success.tsx")))));
	},
	"./ThirdCredentialUploadSuccess": () => {
		return __webpack_require__.e("src_pages_stepup_stepup-docs_third-cred-upload-success_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/stepup-docs/third-cred-upload-success */ "./src/pages/stepup/stepup-docs/third-cred-upload-success.tsx")))));
	},
	"./NameChangeDocSelection": () => {
		return __webpack_require__.e("src_pages_stepup_name-change-doc-selection_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/name-change-doc-selection */ "./src/pages/stepup/name-change-doc-selection.tsx")))));
	},
	"./ChangeOfNameCertificate": () => {
		return __webpack_require__.e("src_pages_stepup_name-change-docs_change-of-name-certificate_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/name-change-docs/change-of-name-certificate */ "./src/pages/stepup/name-change-docs/change-of-name-certificate.tsx")))));
	},
	"./MarriageCertificate": () => {
		return __webpack_require__.e("src_pages_stepup_name-change-docs_marriage-certificate_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/name-change-docs/marriage-certificate */ "./src/pages/stepup/name-change-docs/marriage-certificate.tsx")))));
	},
	"./ExemptNameChange": () => {
		return __webpack_require__.e("src_pages_stepup_name-change-docs_exempt-name-change_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/name-change-docs/exempt-name-change */ "./src/pages/stepup/name-change-docs/exempt-name-change.tsx")))));
	},
	"./NonDvsNameChangeGroupPage": () => {
		return __webpack_require__.e("src_pages_stepup_name-change-docs_non-dvs-name-change-documents_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/name-change-docs/non-dvs-name-change-documents */ "./src/pages/stepup/name-change-docs/non-dvs-name-change-documents.tsx")))));
	},
	"./NameChangeDocUploadSuccess": () => {
		return __webpack_require__.e("src_pages_stepup_name-change-docs_name-change-doc-upload-success_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/name-change-docs/name-change-doc-upload-success */ "./src/pages/stepup/name-change-docs/name-change-doc-upload-success.tsx")))));
	},
	"./TransactionHistory": () => {
		return __webpack_require__.e("src_pages_transaction-history_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/transaction-history */ "./src/pages/transaction-history.tsx")))));
	},
	"./NameConfirmation": () => {
		return __webpack_require__.e("src_pages_name-confirmation_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/name-confirmation */ "./src/pages/name-confirmation.tsx")))));
	},
	"./ThirdDocSelection": () => {
		return __webpack_require__.e("src_pages_stepup_third-doc-selection_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/third-doc-selection */ "./src/pages/stepup/third-doc-selection.tsx")))));
	},
	"./QLDDocuments": () => {
		return __webpack_require__.e("src_pages_stepup_stepup-docs_qld-documents_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/stepup-docs/qld-documents */ "./src/pages/stepup/stepup-docs/qld-documents.tsx")))));
	},
	"./NonDVSGroup1Documents": () => {
		return __webpack_require__.e("src_pages_stepup_stepup-docs_non-dvs-group-1-documents_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/stepup-docs/non-dvs-group-1-documents */ "./src/pages/stepup/stepup-docs/non-dvs-group-1-documents.tsx")))));
	},
	"./NonDVSGroup2Documents": () => {
		return __webpack_require__.e("src_pages_stepup_stepup-docs_non-dvs-group-2-documents_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/stepup-docs/non-dvs-group-2-documents */ "./src/pages/stepup/stepup-docs/non-dvs-group-2-documents.tsx")))));
	},
	"./OverseasMarriageCertificate": () => {
		return __webpack_require__.e("src_pages_stepup_name-change-docs_overseas-marriage-certificate-with-NAATI_tsx").then(() => (() => ((__webpack_require__(/*! ./src/pages/stepup/name-change-docs/overseas-marriage-certificate-with-NAATI */ "./src/pages/stepup/name-change-docs/overseas-marriage-certificate-with-NAATI.tsx")))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});